import React, { useState } from 'react';
import Button from '../../ui/Button';

const defaultBusinessHours = {
  monday: { isOpen: true, intervals: [{ start: '09:00', end: '18:00' }] },
  tuesday: { isOpen: true, intervals: [{ start: '09:00', end: '18:00' }] },
  wednesday: { isOpen: true, intervals: [{ start: '09:00', end: '18:00' }] },
  thursday: { isOpen: true, intervals: [{ start: '09:00', end: '18:00' }] },
  friday: { isOpen: true, intervals: [{ start: '09:00', end: '18:00' }] },
  saturday: { isOpen: true, intervals: [{ start: '09:00', end: '14:00' }] },
  sunday: { isOpen: false, intervals: [{ start: '09:00', end: '18:00' }] }
};

const BusinessHoursStep = ({ onNext, onBack, initialData = {} }) => {
  const [businessHours, setBusinessHours] = useState(() => {
    if (!initialData.businessHours || Object.keys(initialData.businessHours).length === 0) {
      return defaultBusinessHours;
    }

    const hours = { ...defaultBusinessHours };
    
    Object.keys(defaultBusinessHours).forEach(day => {
      if (initialData.businessHours[day]) {
        hours[day] = initialData.businessHours[day];
      }
    });
    
    return hours;
  });
  
  const [showBreakTime, setShowBreakTime] = useState(false);
  
  const daysOfWeek = [
    { id: 'monday', label: 'Segunda-feira' },
    { id: 'tuesday', label: 'Terça-feira' },
    { id: 'wednesday', label: 'Quarta-feira' },
    { id: 'thursday', label: 'Quinta-feira' },
    { id: 'friday', label: 'Sexta-feira' },
    { id: 'saturday', label: 'Sábado' },
    { id: 'sunday', label: 'Domingo' }
  ];
  
  const timeOptions = [];
  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += 30) {
      const formattedHour = hour.toString().padStart(2, '0');
      const formattedMinute = minute.toString().padStart(2, '0');
      timeOptions.push(`${formattedHour}:${formattedMinute}`);
    }
  }
  
  const handleToggleDay = (day) => {
    setBusinessHours({
      ...businessHours,
      [day]: {
        ...businessHours[day],
        isOpen: !businessHours[day].isOpen
      }
    });
  };
  
  const handleTimeChange = (day, intervalIndex, field, value) => {
    const updatedIntervals = [...businessHours[day].intervals];
    updatedIntervals[intervalIndex] = {
      ...updatedIntervals[intervalIndex],
      [field]: value
    };
    
    setBusinessHours({
      ...businessHours,
      [day]: {
        ...businessHours[day],
        intervals: updatedIntervals
      }
    });
  };
  
  const handleAddInterval = (day) => {
    const lastInterval = businessHours[day].intervals[businessHours[day].intervals.length - 1];
    const newInterval = {
      start: lastInterval.end,
      end: lastInterval.end
    };
    
    setBusinessHours({
      ...businessHours,
      [day]: {
        ...businessHours[day],
        intervals: [...businessHours[day].intervals, newInterval]
      }
    });
  };
  
  const handleRemoveInterval = (day, intervalIndex) => {
    if (businessHours[day].intervals.length <= 1) return;
    
    const updatedIntervals = [...businessHours[day].intervals];
    updatedIntervals.splice(intervalIndex, 1);
    
    setBusinessHours({
      ...businessHours,
      [day]: {
        ...businessHours[day],
        intervals: updatedIntervals
      }
    });
  };
  
  const handleApplyToAll = (sourceDayId) => {
    const sourceDay = businessHours[sourceDayId];
    
    const updatedHours = {};
    daysOfWeek.forEach(day => {
      updatedHours[day.id] = {
        ...sourceDay
      };
    });
    
    setBusinessHours(updatedHours);
  };
  
  const toggleBreakTime = () => {
    setShowBreakTime(!showBreakTime);
    
    if (!showBreakTime) {
      const updatedHours = {};
      
      daysOfWeek.forEach(day => {
        if (businessHours[day.id].isOpen) {
          const currentIntervals = businessHours[day.id].intervals;
          
          if (currentIntervals.length === 1) {
            const { start, end } = currentIntervals[0];
            
            const middleTime = "12:00";
            const morningEnd = middleTime;
            const afternoonStart = "13:00";
            
            if (start >= middleTime) {
              updatedHours[day.id] = { ...businessHours[day.id] };
            } else if (end <= middleTime) {
              updatedHours[day.id] = { ...businessHours[day.id] };
            } else {
              updatedHours[day.id] = {
                ...businessHours[day.id],
                intervals: [
                  { start, end: morningEnd },
                  { start: afternoonStart, end }
                ]
              };
            }
          } else {
            updatedHours[day.id] = { ...businessHours[day.id] };
          }
        } else {
          updatedHours[day.id] = { ...businessHours[day.id] };
        }
      });
      
      setBusinessHours(updatedHours);
    } else {
      const updatedHours = {};
      
      daysOfWeek.forEach(day => {
        if (businessHours[day.id].isOpen && businessHours[day.id].intervals.length > 1) {
          const intervals = businessHours[day.id].intervals;
          const firstStart = intervals[0].start;
          const lastEnd = intervals[intervals.length - 1].end;
          
          updatedHours[day.id] = {
            ...businessHours[day.id],
            intervals: [{ start: firstStart, end: lastEnd }]
          };
        } else {
          updatedHours[day.id] = { ...businessHours[day.id] };
        }
      });
      
      setBusinessHours(updatedHours);
    }
  };
  
  const calculateMiddleTime = (start, end) => {
    const startHour = parseInt(start.split(':')[0]);
    const startMinute = parseInt(start.split(':')[1]);
    const endHour = parseInt(end.split(':')[0]);
    const endMinute = parseInt(end.split(':')[1]);
    
    const startTotalMinutes = startHour * 60 + startMinute;
    const endTotalMinutes = endHour * 60 + endMinute;
    const middleTotalMinutes = Math.floor((startTotalMinutes + endTotalMinutes) / 2);
    
    const middleHour = Math.floor(middleTotalMinutes / 60);
    const middleMinute = middleTotalMinutes % 60;
    
    return `${middleHour.toString().padStart(2, '0')}:${middleMinute.toString().padStart(2, '0')}`;
  };
  
  const handleContinue = () => {
    onNext({ businessHours });
  };

  return (
    <div className="animate-fadeIn">
      <h2 className="text-2xl font-semibold text-center text-gray-800 mb-3">
        Horário de funcionamento
      </h2>
      <p className="text-gray-600 text-center mb-8">
        Configure os dias e horários em que seu negócio estará aberto
      </p>

      <div className="bg-white rounded-lg border border-gray-200 shadow-sm mb-8">
        <div className="px-4 py-3 border-b border-gray-200">
          <div className="flex justify-between items-center mb-4">
            <h3 className="font-medium text-gray-800">Horário de atendimento</h3>
            <div className="flex items-center">
              <label htmlFor="breakTime" className="mr-2 text-sm text-gray-600">
                Intervalo para almoço (1 hora)
              </label>
              <div className="relative inline-block w-10 mr-2 align-middle select-none">
                <input
                  type="checkbox"
                  id="breakTime"
                  name="breakTime"
                  checked={showBreakTime}
                  onChange={toggleBreakTime}
                  className="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
                />
                <label
                  htmlFor="breakTime"
                  className="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"
                ></label>
              </div>
            </div>
          </div>
        </div>

        <div className="divide-y divide-gray-100">
          {daysOfWeek.map((day) => (
            <div key={day.id} className="px-4 py-3">
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    id={`day-${day.id}`}
                    checked={businessHours[day.id].isOpen}
                    onChange={() => handleToggleDay(day.id)}
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                  />
                  <label htmlFor={`day-${day.id}`} className="ml-2 text-sm font-medium text-gray-700">
                    {day.label}
                  </label>
                </div>
                {day.id === 'monday' && (
                  <button
                    type="button"
                    onClick={() => handleApplyToAll('monday')}
                    className="text-xs font-medium text-blue-600 hover:text-blue-800"
                  >
                    Aplicar a todos os dias
                  </button>
                )}
              </div>

              {businessHours[day.id].isOpen && (
                <div className="pl-6">
                  {businessHours[day.id].intervals.map((interval, intervalIndex) => (
                    <div key={intervalIndex} className="flex items-center mb-2 last:mb-0">
                      <div className="grid grid-cols-2 gap-2 w-64">
                        <select
                          value={interval.start}
                          onChange={(e) => handleTimeChange(day.id, intervalIndex, 'start', e.target.value)}
                          className="block w-full pl-3 pr-10 py-1.5 text-sm border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 rounded-md"
                        >
                          {timeOptions.map((time) => (
                            <option key={`start-${time}`} value={time}>
                              {time}
                            </option>
                          ))}
                        </select>
                        <select
                          value={interval.end}
                          onChange={(e) => handleTimeChange(day.id, intervalIndex, 'end', e.target.value)}
                          className="block w-full pl-3 pr-10 py-1.5 text-sm border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 rounded-md"
                        >
                          {timeOptions.map((time) => (
                            <option key={`end-${time}`} value={time}>
                              {time}
                            </option>
                          ))}
                        </select>
                      </div>
                      
                      {showBreakTime && (
                        <div className="ml-2 flex items-center">
                          {businessHours[day.id].intervals.length > 1 && (
                            <button
                              type="button"
                              onClick={() => handleRemoveInterval(day.id, intervalIndex)}
                              className="text-red-500 hover:text-red-700 p-1"
                            >
                              <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                              </svg>
                            </button>
                          )}
                          
                          {intervalIndex === businessHours[day.id].intervals.length - 1 && (
                            <button
                              type="button"
                              onClick={() => handleAddInterval(day.id)}
                              className="text-blue-500 hover:text-blue-700 p-1"
                            >
                              <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                              </svg>
                            </button>
                          )}
                        </div>
                      )}
                      
                      {intervalIndex === 0 && businessHours[day.id].intervals.length > 1 && (
                        <span className="ml-2 text-xs text-gray-500">Manhã (até 12h)</span>
                      )}
                      {intervalIndex === 1 && businessHours[day.id].intervals.length > 1 && (
                        <span className="ml-2 text-xs text-gray-500">Tarde (após 13h)</span>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      
      <div className="flex justify-between">
        <Button type="button" variant="outline" onClick={onBack}>
          Voltar
        </Button>
        <Button
          type="button"
          onClick={handleContinue}
        >
          Continuar
        </Button>
      </div>
      
      <style>{`
        .toggle-checkbox:checked {
          right: 0;
          border-color: #3b82f6;
        }
        .toggle-checkbox:checked + .toggle-label {
          background-color: #3b82f6;
        }
      `}</style>
    </div>
  );
};

export default BusinessHoursStep; 